
  <div>
    <p-table #dt [columns]="cols" [value]="tableEntries" dataKey="dataKey" [resizableColumns]="true"
      [scrollable]="true" [scrollHeight]="scrollHeight"
      [customSort]="true" (sortFunction)="doCustomSort($event)"
      [(selection)]="tableSelection" (selectionChange)="onSelectionChange($event)">

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th class="uv-table-checkbox">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          @for (col of columns; track col) {
            <th pResizableColumn [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <td class="uv-table-checkbox">
            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
          </td>
          @for (col of columns; track col) {
            <td>
              <span class="uv-table-value">{{rowData[col.field]}}</span>
            </td>
          }
        </tr>
      </ng-template>

    </p-table>
  </div>

